<div class="image-card">
  <div class="image-card__preview">
    @if (filePreview; as preview) {
      <div class="image-card__file" aria-hidden="true">
        <mat-icon>{{ preview.icon }}</mat-icon>
        <span>{{ preview.label }}</span>
      </div>
    } @else {
      <img alt="" [src]="image.imageUrl" />
    }
  </div>

  <div class="image-card__body">
    <div class="image-card__title" *ngIf="!editMode">
      {{ image.name }}
    </div>
    <form
      [formGroup]="form"
      class="image-card__form"
      (ngSubmit)="changeImage()"
      *ngIf="editMode"
    >
      <mat-form-field appearance="outline">
        <mat-label>{{ "media.images.name" | translate }}</mat-label>
        <input
          matInput
          formControlName="name"
          type="text"
          [errorStateMatcher]="errorStateMatcher"
        />
        <mat-error *ngIf="form.hasError('required', ['name'])">{{
          "fieldRequired" | translate
        }}</mat-error>
      </mat-form-field>
    </form>

    <div class="image-card__actions">
      <button
        type="button"
        class="action-btn action-btn--icon"
        *ngIf="editMode"
        [matTooltip]="'cancel' | translate"
        [attr.aria-label]="'cancel' | translate"
        (click)="cancelEditImage()"
      >
        <mat-icon>close</mat-icon>
      </button>
      <button
        type="button"
        class="action-btn action-btn--icon"
        *ngIf="editMode"
        [matTooltip]="'save' | translate"
        [attr.aria-label]="'save' | translate"
        (click)="changeImage()"
      >
        <mat-icon>save</mat-icon>
      </button>
      <button
        type="button"
        class="action-btn action-btn--icon"
        *ngIf="!editMode"
        [matTooltip]="'edit' | translate"
        [attr.aria-label]="'edit' | translate"
        (click)="changeEditMode()"
      >
        <mat-icon>edit</mat-icon>
      </button>
      <button
        type="button"
        class="action-btn action-btn--icon"
        [matTooltip]="'copyToClipboard' | translate"
        [attr.aria-label]="'copyToClipboard' | translate"
        (click)="copyImageUrlToClipboard()"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
      <button
        type="button"
        class="action-btn action-btn--icon action-btn--danger"
        [matTooltip]="'delete' | translate"
        [attr.aria-label]="'delete' | translate"
        (click)="removeImage(image.imageId)"
      >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </div>
</div>
